import * as Switch from '@radix-ui/react-switch';
import { cn } from '@/lib/cn';

interface Props {
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  disabled?: boolean;
  id?: string;
  'aria-label'?: string;
}

export function Toggle({ checked, onCheckedChange, disabled, id, ...rest }: Props) {
  return (
    <Switch.Root
      id={id}
      checked={checked}
      onCheckedChange={onCheckedChange}
      disabled={disabled}
      className={cn(
        'group relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full transition-colors',
        'data-[state=unchecked]:bg-slate-300 data-[state=checked]:bg-ok',
        'disabled:cursor-not-allowed disabled:opacity-60',
      )}
      {...rest}
    >
      <Switch.Thumb className={cn(
        'pointer-events-none block h-5 w-5 rounded-full bg-white shadow-md transition-transform',
        'translate-x-0.5 group-data-[state=checked]:translate-x-[22px]',
      )} />
    </Switch.Root>
  );
}
